export default "__VITE_ASSET__DDCmM5_t__"